import Box from "./Box";
import PropTypes from "prop-types";
import React from "react";
import Text from "./Text";

function FormError({ name, children, positionProps }) {
  return (
    <Box position="absolute" {...positionProps}>
      <Text color="error">{children}</Text>
    </Box>
  );
}

FormError.propTypes = {
  children: PropTypes.string.isRequired,
  positionProps: PropTypes.object,
};

export default FormError;
